import React from 'react';

import { FlagOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { SearchForecastDTO } from '@recurrency/core-api-schema/dist/search/getSearchForecasts';
import { Tooltip } from 'antd';
import { colors } from 'theme/colors';

import { Button } from 'components/Button';

import { showAsyncModal } from 'utils/asyncModal';

import { IdNameObj } from 'types/legacy-api';

import { ReportForecastModal } from './ReportForecastModal';

export function ReportForecastTitle({
  title,
  itemId,
  itemUid,
  locations,
  forecastRecords,
}: {
  title: React.ReactNode;
  itemId: string;
  itemUid: string;
  locations: IdNameObj[];
  forecastRecords: SearchForecastDTO[] | undefined;
}) {
  return (
    <div
      className={css`
        display: flex;
        align-items: center;
        gap: 8px;
      `}
    >
      <span
        className={css`
          flex: 1;
          min-width: 0;
        `}
      >
        {title}
        {forecastRecords?.[0]?.item_desc ? (
          <div
            className={css`
              color: ${colors.neutral[400]};
              font-size: 14px;
              font-weight: normal;
            `}
          >
            {forecastRecords[0].item_desc}
          </div>
        ) : null}
      </span>
      <span
        className={css`
          flex-shrink: 0;
          margin-right: 40px;
        `}
      >
        <Tooltip title="Report forecast">
          <Button
            type="text"
            size="small"
            icon={<FlagOutlined />}
            className={css`
              &.ant-btn {
                color: rgba(0, 0, 0, 0.45);
                &:hover {
                  color: rgba(0, 0, 0, 0.75);
                  background: transparent;
                }
              }
            `}
            onClick={(e) => {
              e.stopPropagation();
              showAsyncModal(ReportForecastModal, {
                itemId,
                itemUid,
                locations,
                forecastRecords,
              });
            }}
          />
        </Tooltip>
      </span>
    </div>
  );
}
